<template>
  <div class="newrealauth">
     <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          title="证件上传"
          @click-left="closePage"
      >
      </z-nav-bar>
    </z-fix-top>
    <!-- 提交状态 -->
    <template v-if="!result">
      <div class="commit-info">
        <div class="guide-title">请上传{{ name }}本人的{{ titlemap[authType] }}</div>
        <div class="guide-info">根据法律法规和监管要求，为保障平台交易安全，需要收集您的身份信息用于实人认证，{{ isSJJ ? '奢竞界' : (isZLJ ? '找靓机' : '转转') }}将保护您的个人信息安全。</div>
        <section v-if="['0','1'].includes(authType)" class="upload-area">
          <media-upload-item :sdkOptions="{ type: '1' }" :authType="authType" :cover="frontCover" :tip="frontTip" type="front" @uploaded="frontPicUploaded">
          </media-upload-item>
          <media-upload-item :sdkOptions="{ type: '1' }" :authType="authType" :cover="backCover" :tip="backTip" type="back" @uploaded="backPicUploaded">
          </media-upload-item>
        </section>
        <section v-else class="upload-area-single">
          <media-upload-item :authType="authType" :cover="frontCover" :tip="frontTip" type="front" @uploaded="frontPicUploaded">
          </media-upload-item>
        </section>
        <z-checkbox-group v-model="radio">
          <z-checkbox v-if="isZZ" name="zz">
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="zzagreement">《实人认证服务协议》</span>
          </z-checkbox>

          <z-checkbox v-if="isSJJ" name="sjj">
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="sjjagreement">《实人认证服务协议》</span>
          </z-checkbox>

          <z-checkbox name="privacy">
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="checkInfo">《个人信息处理授权书》</span>
          </z-checkbox>

          <z-checkbox v-if="isZLJ" name="zlj">
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="zljagreement">《找靓机身份识别服务协议》</span>
          </z-checkbox>
        </z-checkbox-group>
        <z-button-group>
          <z-button type="primary" :loading="submiting" :disabled="!canSubmit" @click="submit">提交</z-button>
        </z-button-group>
      </div>
    </template>

    <!-- 结果状态 -->
    <template v-if="result">
      <div class="real-auth-result">
        <!-- generated by ai -->
        <img :src="$setPicSize(successImg)" alt="">
        <header>{{ desc }}</header>
        <z-button type="primary" @click="closePage">返回</z-button>
      </div>
    </template>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { NavBar, Button, ButtonGroup, FixTop, Checkbox, CheckboxGroup, Dialog } from '@zz-common/zz-ui';
import { privateInfoCardSupply, apiNewRealAuthSubmitHandle } from '@api/resourceApi'
import MediaUploadItem from './MediaUploadItem/MediaUploadItem'
import { lego } from '@zz-common/lego'
// generated by ai
import { setPicSize } from '@zz-common/zz-utils'
import { queryParams, getCookie } from '../../../lib/utils'

const query = queryParams()

export default {
  name: 'CommitInfo',
  data() {
    // 获取Cookie中的t值判断是否为奢竞界APP
    const tValue = getCookie('t')
    const isSJJ = tValue === '243' || tValue === '244'
    return {
      radio: [],
      picKeyFro: '',
      picKeyBack: '',
      //顶部文字
      title: '',
      successImg: require('./images/auth_success.png'),
      name: decodeURI(query.name) || decodeURI(this.$route.query.name) || '',
      // 如果URL没有传sourcecode，根据不同APP设置默认值
      sourcecode: query.sourcecode || this.$route.query.sourcecode || (isSJJ ? 'c2p_selfmain_page' : 'card_selfmain_page'),
      authType: query.authType || this.$route.query.authType, //认证方式
      result: false,
      submiting: false,
      actions: [
        { name: '中华人民共和国居民身份证', value: '0' },
        { name: '中华人民共和国港澳台居民居住证', value: '1' },
        { name: '港澳居民来往内地通行证', value: '2' },
        { name: '台湾居民来往大陆通行证', value: '3' }
      ],
      titlemap: {
        0: '身份证',
        1: '居住证',
        2: '通行证',
        3: '通行证'
      },
      isZZ: native.in('zz'),
      isZLJ: native.in('zlj'),
      isSJJ, // 奢竞界APP
      frontCover1: require('@assets/img/id_card_front_sample_new.png'),
      frontCover2: require('@assets/img/id_card_entrance_new.png'),
      backCover1: require('@assets/img/id_card_back_sample_new.png'),
      desc: '恭喜您认证成功',
      backTip: '',
      frontTip: ''
    }
  },
  computed: {
    /**
     * 判断是否可以提交
     * 需要满足：图片上传完成 + 所有协议都已勾选
     */
    canSubmit() {
      // 图片上传校验
      const hasPicture = ['0', '1'].includes(this.authType)
        ? (this.picKeyFro && this.picKeyBack)
        : this.picKeyFro

      // 协议勾选校验
      // 个人信息处理授权书（必选）
      const hasPrivacy = this.radio.includes('privacy')
      // 转转实人认证服务协议（如果显示）
      const hasZZ = !this.isZZ || this.radio.includes('zz')
      // 找靓机身份识别服务协议（如果显示）
      const hasZLJ = !this.isZLJ || this.radio.includes('zlj')
      // 奢竞界实人认证服务协议（如果显示）
      const hasSJJ = !this.isSJJ || this.radio.includes('sjj')

      return hasPicture && hasPrivacy && hasZZ && hasZLJ && hasSJJ
    },
    cardType() {
      return this.actions.find(t => t.value == this.authType)?.name || '-'
    },
    frontCover() {
      if (['0', '1'].includes(this.authType)) {
        return this.frontCover1
      } else {
        return this.frontCover2
      }
    },
    backCover() {
      return this.backCover1
    }
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button,
    'z-checkbox-group': CheckboxGroup,
    'z-checkbox': Checkbox,
    'z-button-group': ButtonGroup,
    MediaUploadItem
  },
  mounted() {
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
    lego.send({
      pagetype: 'auth_cardsupply',
      actiontype: 'show',
      backup: {
        sourcecode: this.sourcecode,
        version: getCookie('v'),
        app: native.in('zz') ? 'zz' : 'zlj',
        authType: this.authType
      }
    })
  },
  methods: {
    // generated by ai
    $setPicSize(url) {
      return setPicSize(url)
    },
    zzagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/67e371c0da1f4e0062fc0d97/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    zljagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401c5d7c955420077193c75/index.html?magicplatform=zlj&needNewWebview=1',
        needClose: '0'
      })
    },
    sjjagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/691c3375ee471600647e64f8/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    checkInfo() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401a9e6447e27006914ecb0/index.html?magicplatform=common&needNewWebview=1',
        needClose: '0'
      })
    },
    frontPicUploaded(rst, ocr = '') {
      this.picKeyFro = rst
      if (ocr && !this.name && !this.cardId) {
        this.name = ocr.name
        this.cardId = ocr.cardId
      }
    },
    backPicUploaded(rst, _ocr = '') {
      this.picKeyBack = rst
    },
    submit() {
      lego.send({
        pagetype: 'auth_cardsupply',
        actiontype: 'submit',
        backup: {
          sourcecode: this.sourcecode,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj',
          authType: this.authType
        }
      })
      this.submiting = true
      const params = {
        sourcecode: this.sourcecode,
        picKeyFro: this.picKeyFro,
        picKeyBack: this.picKeyBack,
        type: this.authType
      }
      privateInfoCardSupply(params)
        .then((res) => {
          if (res != true) {
            lego.send({
              pagetype: 'auth_cardsupply',
              actiontype: 'fail',
              backup: {
                sourcecode: this.sourcecode,
                version: getCookie('v'),
                app: native.in('zz') ? 'zz' : 'zlj',
                authType: this.authType
              }
            })
            Dialog({
              title: '信息审核未通过',
              message: '经系统检测，提交证件信息与填写信息信息不一致，请确认信息是否正确，如信息无误，可提交人工审核，审核通过后不可更改。',
              confirmButtonText: '确认无误，提交审核',
              business: true,
              showTopClose: true,
              closeOnClickOverlay: false
            }).then(() => {
              apiNewRealAuthSubmitHandle({
                ...params,
                complement: 'complement'
              }).then(_res => {
                this.result = true
                this.desc = '您的申请已提交成功，请耐心等待'
              }).catch(err => {
                console.log(err)
              //this.$toast('提交失败')
              })
            });
          } else {
            lego.send({
              pagetype: 'auth_cardsupply',
              actiontype: 'success',
              backup: {
                sourcecode: this.sourcecode,
                version: getCookie('v'),
                app: native.in('zz') ? 'zz' : 'zlj',
                authType: this.authType
              }
            })
            this.result = true
          }
          this.submiting = false
        })
        .catch((res) => {
          console.log(res)
          this.submiting = false
        })
    },
    closePage() {
      native.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
